import { render } from "./PinkBack.svg?vue&type=template&id=766f2d06"
const script = {}
script.render = render

export default script